import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/auth/hooks';
import { authService } from '@/auth/authService';
import { START_PATH } from '@/app/routes';

// Port of LoginScreen.kt — logo/title + "Sign in with Tipmi" full-page redirect to backend OAuth2.
export function LoginPage() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to={START_PATH} replace />;

  const error = new URLSearchParams(window.location.search).get('error');

  return (
    <div className="flex h-dvh items-center justify-center bg-background p-8 text-foreground">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Welcome to TipMi Admin</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <p className="text-sm text-destructive">Sign-in failed. Please try again.</p>
          )}
          <Button className="w-full" onClick={() => authService.login()}>
            Sign in with Tipmi
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
